import React, { useState } from 'react';
import img1 from '../assets/photos/IMG_0678.JPG';
import img2 from '../assets/photos/IMG_2029.JPG';
import img3 from '../assets/photos/IMG_2204.JPEG';
import img4 from '../assets/photos/IMG_2538.JPG';
import img5 from '../assets/photos/IMG_3516.JPG';

const photos = [img1, img2, img3, img4, img5];

const PhotoGrid: React.FC = () => {
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    return (
        <section className="bg-cream py-24 md:py-32 px-4">
            <div className="max-w-6xl mx-auto" style={{ containerType: 'inline-size' }}>
                <p className="font-sans text-[10px] md:text-xs tracking-[0.4em] uppercase text-gold mb-4">
                    галерея
                </p>
                <h2 className="font-script text-4xl md:text-6xl text-prussian_blue mb-6">Наши моменты</h2>
                <div className="flex items-center justify-center gap-3 mb-14 divider-ornament max-w-xs mx-auto">
                    <span className="text-gold text-xl animate-heart">♥</span>
                </div>
                <div className="grid grid-cols-3 gap-3 md:gap-4" style={{ gridTemplateRows: 'repeat(6, 14.5cqw)' }}>
                    <div className="photo-item col-span-1 row-span-3 rounded-2xl shadow-card cursor-pointer group" onClick={() => setSelectedImage(photos[0])}>
                        <img src={photos[0]} alt="" className="w-full h-full object-cover rounded-2xl group-hover:scale-105 transition-transform duration-700 ease-out" />
                    </div>
                    <div className="photo-item col-span-1 row-span-3 rounded-2xl shadow-card cursor-pointer group" onClick={() => setSelectedImage(photos[1])}>
                        <img src={photos[1]} alt="" className="w-full h-full object-cover rounded-2xl group-hover:scale-105 transition-transform duration-700 ease-out" />
                    </div>
                    <div className="photo-item col-span-1 row-span-3 rounded-2xl shadow-card cursor-pointer group" onClick={() => setSelectedImage(photos[2])}>
                        <img src={photos[2]} alt="" className="w-full h-full object-cover rounded-2xl group-hover:scale-105 transition-transform duration-700 ease-out" />
                    </div>
                    <div className="photo-item col-span-1 row-span-3 rounded-2xl shadow-card cursor-pointer group" onClick={() => setSelectedImage(photos[3])}>
                        <img src={photos[3]} alt="" className="w-full h-full object-cover rounded-2xl group-hover:scale-105 transition-transform duration-700 ease-out" />
                    </div>
                    <div className="photo-item col-span-2 row-span-3 rounded-2xl shadow-card cursor-pointer group" onClick={() => setSelectedImage(photos[4])}>
                        <img src={photos[4]} alt="" className="w-full h-full object-cover rounded-2xl group-hover:scale-105 transition-transform duration-700 ease-out" />
                    </div>
                </div>
            </div>

            {selectedImage && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 backdrop-blur-md cursor-pointer animate-fadeIn"
                    onClick={() => setSelectedImage(null)}
                >
                    <img
                        src={selectedImage}
                        alt=""
                        className="max-h-[90vh] max-w-[90vw] object-contain rounded-xl shadow-2xl animate-scaleIn"
                        onClick={() => setSelectedImage(null)}
                    />
                </div>
            )}
        </section>
    );
};

export default PhotoGrid;
